export const SKILLS_ADMIN_LIST_REQUEST = "SKILLS_ADMIN_LIST_REQUEST";
export const SKILLS_ADMIN_LIST_SUCCESS = "SKILLS_ADMIN_LIST_SUCCESS";
export const SKILLS_ADMIN_LIST_FAIL = "SKILLS_ADMIN_LIST_FAIL";

export const SKILLS_MANUAL_UPLOAD_REQUEST = "SKILLS_MANUAL_UPLOAD_REQUEST";
export const SKILLS_MANUAL_UPLOAD_SUCCESS = "SKILLS_MANUAL_UPLOAD_SUCCESS";
export const SKILLS_MANUAL_UPLOAD_FAIL = "SKILLS_MANUAL_UPLOAD_FAIL";

export const SKILLS_CSV_UPLOAD_REQUEST = "SKILLS_CSV_UPLOAD_REQUEST";
export const SKILLS_CSV_UPLOAD_SUCCESS = "SKILLS_CSV_UPLOAD_SUCCESS";
export const SKILLS_CSV_UPLOAD_FAIL = "SKILLS_CSV_UPLOAD_FAIL";

export const SKILLS_BULK_VERIFY_REQUEST = "SKILLS_BULK_VERIFY_REQUEST";
export const SKILLS_BULK_VERIFY_SUCCESS = "SKILLS_BULK_VERIFY_SUCCESS";
export const SKILLS_BULK_VERIFY_FAIL = "SKILLS_BULK_VERIFY_FAIL";
